import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Age {
  AGE_18 = "18",
  AGE_19 = "19",
  AGE_20 = "20",
  AGE_21 = "21",
  AGE_22 = "22",
  AGE_23 = "23",
  AGE_24 = "24",
  AGE_25 = "25",
  AGE_26 = "26",
  AGE_27 = "27",
  AGE_28 = "28",
  AGE_29 = "29",
  AGE_30 = "30",
  AGE_31 = "31",
  AGE_32 = "32",
  AGE_33 = "33",
  AGE_34 = "34",
  AGE_35 = "35",
  AGE_36 = "36",
  AGE_37 = "37",
  AGE_38 = "38",
  AGE_39 = "39",
  AGE_40 = "40",
  AGE_41 = "41",
  AGE_42 = "42",
  AGE_43 = "43",
  AGE_44 = "44",
  AGE_45 = "45",
  AGE_46 = "46",
  AGE_47 = "47",
  AGE_48 = "48",
  AGE_49 = "49",
  AGE_50 = "50",
  AGE_51 = "51",
  AGE_52 = "52",
  AGE_53 = "53",
  AGE_54 = "54",
  AGE_55 = "55",
  AGE_56 = "56",
  AGE_57 = "57",
  AGE_58 = "58",
  AGE_59 = "59",
  AGE_60_OR_OLDER = "60",
}

const AGE_ATTRIBUTE_VALUES: ReadonlyArray<AttributeValue> = [
  { id: Age.AGE_18, label: "18", iconLabel: "" },
  { id: Age.AGE_19, label: "19", iconLabel: "" },
  { id: Age.AGE_20, label: "20", iconLabel: "" },
  { id: Age.AGE_21, label: "21", iconLabel: "" },
  { id: Age.AGE_22, label: "22", iconLabel: "" },
  { id: Age.AGE_23, label: "23", iconLabel: "" },
  { id: Age.AGE_24, label: "24", iconLabel: "" },
  { id: Age.AGE_25, label: "25", iconLabel: "" },
  { id: Age.AGE_26, label: "26", iconLabel: "" },
  { id: Age.AGE_27, label: "27", iconLabel: "" },
  { id: Age.AGE_28, label: "28", iconLabel: "" },
  { id: Age.AGE_29, label: "29", iconLabel: "" },
  { id: Age.AGE_30, label: "30", iconLabel: "" },
  { id: Age.AGE_31, label: "31", iconLabel: "" },
  { id: Age.AGE_32, label: "32", iconLabel: "" },
  { id: Age.AGE_33, label: "33", iconLabel: "" },
  { id: Age.AGE_34, label: "34", iconLabel: "" },
  { id: Age.AGE_35, label: "35", iconLabel: "" },
  { id: Age.AGE_36, label: "36", iconLabel: "" },
  { id: Age.AGE_37, label: "37", iconLabel: "" },
  { id: Age.AGE_38, label: "38", iconLabel: "" },
  { id: Age.AGE_39, label: "39", iconLabel: "" },
  { id: Age.AGE_40, label: "40", iconLabel: "" },
  { id: Age.AGE_41, label: "41", iconLabel: "" },
  { id: Age.AGE_42, label: "42", iconLabel: "" },
  { id: Age.AGE_43, label: "43", iconLabel: "" },
  { id: Age.AGE_44, label: "44", iconLabel: "" },
  { id: Age.AGE_45, label: "45", iconLabel: "" },
  { id: Age.AGE_46, label: "46", iconLabel: "" },
  { id: Age.AGE_47, label: "47", iconLabel: "" },
  { id: Age.AGE_48, label: "48", iconLabel: "" },
  { id: Age.AGE_49, label: "49", iconLabel: "" },
  { id: Age.AGE_50, label: "50", iconLabel: "" },
  { id: Age.AGE_51, label: "51", iconLabel: "" },
  { id: Age.AGE_52, label: "52", iconLabel: "" },
  { id: Age.AGE_53, label: "53", iconLabel: "" },
  { id: Age.AGE_54, label: "54", iconLabel: "" },
  { id: Age.AGE_55, label: "55", iconLabel: "" },
  { id: Age.AGE_56, label: "56", iconLabel: "" },
  { id: Age.AGE_57, label: "57", iconLabel: "" },
  { id: Age.AGE_58, label: "58", iconLabel: "" },
  { id: Age.AGE_59, label: "59", iconLabel: "" },
  { id: Age.AGE_60_OR_OLDER, label: "60 or older", iconLabel: "" },
];

export const UserAgeAttributeSet: UserAttributeSet = {
  id: UserAttributeType.AGE,
  isMultiSelect: false,
  map: attributeListToMap(AGE_ATTRIBUTE_VALUES),
} as const;
